import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Card } from "antd";
import whiteLogo from "../../Assets/logo1.png";
import { Image } from "react-bootstrap";
import "./Contact.scss";

const Contact = () => {
  return (
    <>
      <Container fluid className="page-top-settings contact-section" id="contact">
        <Container className="contact-content">
          {/* Contact Title */}
          <Row>
            <div className="page-title">
              <h2 className="shaking center-text">
                Get in Touch with <span className="extra">Funda Sourcing</span>!
                <p>Reach out and let’s connect.
              </p>
              </h2>
            </div>
          </Row>

          {/* Contact Information Cards */}
          <Row className="equal-height-cards justify-center">
            {/* Email Contact Card */}
            <Col md={6} className="d-flex">
              <Card className="box flex-fill">
                <section className="contact-info">
                  <Image
                    src={whiteLogo}
                    alt="Source from Asia"
                    className="source-logo-contact"
                  />
                  <h1>Email Us</h1>
                  <p className="contact-details">
                    
                    📧 Email us at &nbsp;
                    <a
                    href="mailto:hello@fundasourcing.com"
                    className="email contact-email">hello@fundasourcing.com</a> and we’ll get back to you promptly.</p>
                    <p className="contact-details">📍 Our office is located in Columbus, Ohio.</p>
                  
                  
                  
                </section>
              </Card>
            </Col>

          </Row>

        </Container>
      </Container>
    </>
  );
};

export default Contact;
